// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "TestimonialsSection-module--wrapper--5e1-Z";
export var sectionTitle = "TestimonialsSection-module--sectionTitle--zu-cp";
export var slide = "TestimonialsSection-module--slide--Sg5Rb";
export var counter = "TestimonialsSection-module--counter--BwlLv";